module.exports = __webpack_public_path__ + "media/images/emoticons/rouge-148ad01e55982b4aec64a0eb41c11241.gif";